import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ClinicBookingHeader2 from "./ClinicBookingHeader2";
import ClinicBookingFooter from "./ClinicBookingFooter";
import Loader2 from "../Loader2";
import moment from "moment-timezone";

function ClinicShareAppointmentDetails() {
    const [loading, setLoading] = useState(false);
    const [shareData, setShareData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Retrieve shared appointment data from localStorage
        const storedShareData = localStorage.getItem("shareAppointmentData");
        if (storedShareData) {
            setShareData(JSON.parse(storedShareData));
        } else {
            // If no share data, redirect back to patient landing
            navigate("/patientLanding");
        }
    }, [navigate]);

    if (!shareData) {
        return <Loader2 />;
    }

    return (
        <>
            <ClinicBookingHeader2
                logoImage="" // You may want to pass the clinic logo here
                Phone={shareData.clinicInfo?.phone || ""}
                Street=""
                address={shareData.clinicInfo?.address || ""}
                clinicname={shareData.clinicInfo?.name || ""}
            />
            <ShareAppointmentDetails
                loading={loading}
                setLoading={setLoading}
                shareData={shareData}
            />
            <ClinicBookingFooter />
        </>
    );
}

function ShareAppointmentDetails({ loading, setLoading, shareData }) {
    const navigate = useNavigate();

    const handleBookAnotherAppointment = () => {
        // Clear any stored data
        localStorage.removeItem("shareAppointmentData");
        localStorage.removeItem("selectedSlot");
        localStorage.removeItem("selectedOptions");
        localStorage.removeItem("selectedDate");
        localStorage.removeItem("selectedDoctor");
        localStorage.removeItem("options");
        localStorage.removeItem("doctorsData");
        localStorage.removeItem("optionsId");

        navigate(`/patientLanding`);
    };

    return (
        <>
            {loading ? (
                <Loader2 />
            ) : (
                <section>
                    <div className="container mx-auto px-4 py-4">
                        <h1 className="font-fontPoppins text-3xl xss:text-xl sm:text-xl font-bold text-center mb-7">
                            Appointment Share
                        </h1>

                        <div className="xss:w-full sm:w-full mx-auto relative bg-gray-100 px-4 py-5 shadow-md rounded-xl xss:mt-3 sm:mt-3 md:mt-0">
                            <div className="w-full mt-4 bg-green-100 px-4 py-2 rounded-lg shadow-sm">
                                <h4 className="font-fontPoppins text-lg font-semibold text-green-800">
                                    Appointment Shared Successfully!
                                </h4>
                                <p className="font-fontPoppins text-sm font-normal text-green-700">
                                    This appointment invitation has been shared with  {shareData.patientContactData.firstName} at {shareData.patientContactData.email}. {shareData.patientContactData.firstName} will receive all future updates and will be able to manage their appointment directly.
                                </p>
                            </div>
                        </div>

                        <div className="xss:w-full sm:w-full mx-auto mt-4 xss:text-center md:flex md:justify-center md:gap-4">
                            <button
                                onClick={handleBookAnotherAppointment}
                                className="h-12 font-fontPoppins hover:bg-gray-300 text-sm rounded-full text-gray-600 font-semibold hover:opacity-85 px-6 xss:mb-2"
                            >
                                Book Another Appointment
                                <i className="fa-solid fa-arrow-right-long fa-lg ml-2"></i>
                            </button>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
}

export default ClinicShareAppointmentDetails;